import { render, staticRenderFns } from "./UploadFileComponent.vue?vue&type=template&id=da8d4fc4&scoped=true"
import script from "./UploadFileComponent.vue?vue&type=script&lang=js"
export * from "./UploadFileComponent.vue?vue&type=script&lang=js"
import style0 from "./UploadFileComponent.vue?vue&type=style&index=0&id=da8d4fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8d4fc4",
  null
  
)

export default component.exports